import type { ContentObjectList } from 'models';
import { PinnedGivingCard } from '../pinned-giving-card';
import { PinnedPostCard } from '../pinned-post-card';

type P = {
  item: ContentObjectList;
};

const PinnedCardRenderer = ({ item }: P) => {
  switch (item.type) {
    case 'activity':
    case 'comment':
    case 'event':
    case 'video':
    case 'withings_order_post':
      return null;
    case 'giving':
      return <PinnedGivingCard item={item} />;
    case 'kudo':
    case 'poll':
    case 'post':
      return <PinnedPostCard item={item} />;
  }
};

export default PinnedCardRenderer;
